import React from 'react';
import { Checkbox } from '../../index';

interface IInvoiceCheckboxProps {
	createInvoice: boolean;
	setCreateInvoice: (invoice: boolean) => void;
	label?: string;
}

export const InvoiceCheckbox = ({
	createInvoice,
	setCreateInvoice,
	label = 'Ich benötige eine Rechnung mit meinem Namen und Anschrift',
}: IInvoiceCheckboxProps) => {
	const handleCheckboxToggle = (isChecked: boolean) => {
		setCreateInvoice(isChecked);
		sessionStorage.setItem('additionalInfo', JSON.stringify({ createInvoice: isChecked }));
	};

	return (
		<Checkbox
			data-cy="checkbox: invoice"
			title={label}
			className="items-center px-4 py-3 border border-solid border-gray-500 rounded mb-5"
			label={label}
			size="lg"
			checked={createInvoice}
			setChecked={handleCheckboxToggle}
		/>
	);
};
